import defaultState from "./state";

const filtroBusquedaSRReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_SOLICITUDES": {
      return Object.assign({}, state, {
        loading: false,
        solicitudes: action.solicitudes,
      });
    }

    case "FILTROBUSQUEDASR/LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "FILTROBUSQUEDASR/CAMBIAR_TIPO_SOLICITUD": {
      const filtros = Object.assign({}, state.filtros, {
        tipoSolicitud: action.tipoSolicitud,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "FILTROBUSQUEDASR/CAMBIAR_ESTADO_SOLICITUD": {
      const filtros = Object.assign({}, state.filtros, {
        estadoSolicitud: action.estadoSolicitud,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "FILTROBUSQUEDASR/CAMBIAR_IDSOLICITUD": {
      const filtros = Object.assign({}, state.filtros, {
        idSolicitud: action.valor,
        idSolicitudError: action.error,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "FILTROBUSQUEDASR/CAMBIAR_FECHA_SOLICITUD_DESDE": {
      const filtros = Object.assign({}, state.filtros, {
        fechaSolicitudDesde: action.valor,
        fechaSolicitudDesdeError: action.error,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "FILTROBUSQUEDASR/CAMBIAR_FECHA_SOLICITUD_HASTA": {
      const filtros = Object.assign({}, state.filtros, {
        fechaSolicitudHasta: action.valor,
        fechaSolicitudHastaError: action.error,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaSRReducer;



// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/FiltroBusqueda/reducer.js